document.addEventListener("DOMContentLoaded", () => {
  // Buscar todos los componentes icon-list que tengan un icono personalizado
  const iconLists = document.querySelectorAll(".icon-list[data-icon-id]");

  iconLists.forEach((iconList) => {
    // Obtener el ID del template con el icono
    const iconId = iconList.getAttribute("data-icon-id");

    if (iconId) {
      // Buscar el template con el icono
      const iconTemplate = document.getElementById(iconId);
      const iconDataColor = iconTemplate
        ? iconTemplate.getAttribute("data-color")
        : null;

      if (iconTemplate) {
        // Obtener el elemento del icono del template
        const iconElement = iconTemplate.content.firstElementChild;
        if (iconDataColor) {
          // Add iconDataColor as a class element to icon element
          iconElement.classList.add(iconDataColor);
        }

        if (iconElement) {
          // Buscar todos los elementos <li> dentro de este icon-list
          const listItems = iconList.querySelectorAll(".icon-list__list li");

          listItems.forEach((li) => {
            // Clonar el icono e insertarlo al inicio del <li>
            const iconClone = iconElement.cloneNode(true);
            li.insertAdjacentElement("afterbegin", iconClone);
          });
        }

        // Eliminar el template después de usarlo
        iconTemplate.remove();
      }
    }
  });
});
